module.exports = __webpack_public_path__ + "static/media/img-purchase-logo-large.25c502f5.svg";